export const AppConstants = {
  componentId: 5,
  platformAdminT1GroupId: 'ba2233f5-d1c8-4d50-842e-a020b409f78f'
}

export const TenantComponentStatus = {  
  1 : 'InProgress',
  2 : 'Success',
  3 : 'Failed'
}

export enum TenantActivityType {
  DELETE = 0,
  IMPORT = 1,
  EXPORT = 2
}

